import { datadogLogs } from '@datadog/browser-logs';
export const logger = datadogLogs.logger;
export { FeatureName, LogPrefix, ApplicationLaunchResult } from './types';
export { initDatadog, setDatadogUser, clearDatadogUser } from './datadog';
